export default "__VITE_ASSET__BBrg8Lp9__"